export enum PageType {
  PROCESS_WELCOME = 'PROCESS_WELCOME',
  ADD = 'ADD',
  SEARCH = 'SEARCH',
  DETAIL = 'DETAIL',
  PROCESS_CONTACT_LEADS = 'PROCESS_CONTACT_LEADS',
  PROCESS_CONTACT_COLD_LEADS = 'PROCESS_CONTACT_COLD_LEADS',
  PROCESS_CONTACT_SURVEYS = 'PROCESS_CONTACT_SURVEYS',
}

export enum EventRegistryType {
  PHONE_CALL_OUTBOUND = 'PHONE_CALL_OUTBOUND',
  PHONE_CALL_INBOUND = 'PHONE_CALL_INBOUND',
  MOBILE_CALL_OUTBOUND = 'MOBILE_CALL_OUTBOUND',
  EMAIL_OUTBOUND = 'EMAIL_OUTBOUND',
}

export type CallCenterContactPageType = PageType.PROCESS_CONTACT_LEADS | PageType.PROCESS_CONTACT_COLD_LEADS | PageType.PROCESS_CONTACT_SURVEYS | PageType.DETAIL;
